// extracted by mini-css-extract-plugin
export default {"gallery":"styles_gallery__7+kTn","slider":"styles_slider__wDmas","slide":"styles_slide__zpK4w","slideImage":"styles_slideImage__MmwEl"};